import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-multiple-select',
  templateUrl: './multiple-select.component.html',
  styleUrls: ['./multiple-select.component.css'],
})
export class MultipleSelectComponent {
  @Input() isMissing = false;
  @Input() question!: Question;
  @Input() index!: number;
  @Output() answerSelected = new EventEmitter<{
    questionUuid: string;
    answerValue: {
      choice: string;
      other?: string;
    };
  }>();

  selectedValues: string[] = [];
  otherInputs: Record<string, string> = {};

  handleCheckboxChange(value: string, hasInput: boolean): void {
    const index = this.selectedValues.indexOf(value);

    if (index > -1) {
      this.selectedValues.splice(index, 1);
      if (Object.hasOwn(this.otherInputs, value)) {
        Reflect.deleteProperty(this.otherInputs, value);
      }
    } else {
      this.selectedValues.push(value);
      if (hasInput && !Object.hasOwn(this.otherInputs, value)) {
        Reflect.set(this.otherInputs, value, '');
      }
    }

    this.emitAnswer();
  }

  updateOtherText(uuid: string, value: string): void {
    Reflect.set(this.otherInputs, uuid, value);
    this.emitAnswer();
  }

  emitAnswer(): void {
    const otherTexts: string[] = [];

    for (const uuid of this.selectedValues) {
      const descriptor = Object.getOwnPropertyDescriptor(this.otherInputs, uuid);
      const text = descriptor?.value;

      if (typeof text === 'string' && text.trim()) {
        otherTexts.push(text.trim());
      }
    }

    const otherCombined = otherTexts.join(', ');

    this.answerSelected.emit({
      questionUuid: this.question.uuid,
      answerValue: {
        choice: this.selectedValues.join(',') || '',
        other: otherCombined || undefined,
      },
    });
  }

  get questionHtml(): string {
    const html = this.question.question || '';
    if (!this.question.is_required) {
      return html;
    }
    const marker = ' <span style="color:#dc2626">*</span>';
    const lastCloseTagIndex = html.toLowerCase().lastIndexOf('</p>');
    if (lastCloseTagIndex === -1) {
      return html + marker;
    }
    return html.slice(0, lastCloseTagIndex) + marker + html.slice(lastCloseTagIndex);
  }
}
